import createModule from "../createModule"
import view from "./view"
import { get } from "lodash"
import { Creators } from "model/hookUpdater"
import { getRole } from "helpers/permissions/roles"
import { getDatasetTeams, getTeams, getTabs } from "./selectors"
import withUrlParams from "hocs/withUrlParams"

import "./styles.scss"

export default withUrlParams(createModule({
  view,
  externalProps: (state, props) => ({
    account: get(state, "global.selected.account"),
    datasetId: get(props, "params.datasetId"),
  }),
  required: ["account", "datasetId"],
  data: [{
    resource: "teams",
    url: () => {
      return {
        id: "teams",
        query: `query {
          teams {
            id
            alias
            name
          }
        }`,
      }
    },
  },
  {
    resource: "datasetTeamEntitlements",
    url: ({ account, datasetId }) => `/api/${account}/reports/entitlements/dataset/${datasetId}/teams`,
  }],
  mapStateToProps: (state, props) => ({
    role: getRole(state),
    userId: get(state, "user.id"),
    datasetTeams: getDatasetTeams(state, props),
    teams: getTeams(state, props),
    tabs: getTabs(state, props),
  }),
  actions: {
    ...Creators,
  },
}))
